export default "__VITE_ASSET__F6$X2bjT__"